import {Component, OnDestroy, OnInit} from '@angular/core';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {Observable, Subject} from 'rxjs';
import {DialogModel} from '@shared/models/dialog.model';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {takeUntil} from 'rxjs/operators';
import {DataSurveyService} from '../../services/data-survey.service';
import { MatRadioChange } from '@angular/material/radio';

@Component({
    standalone: false,
    selector: 'particle-export-survey-response-dialog',
  templateUrl: './export-survey-response-dialog.component.html',
  styleUrls: ['./export-survey-response-dialog.component.scss']
})
export class ExportSurveyResponseDialogComponent implements OnInit, OnDestroy, IDialogView {

  dropdownData$: Observable<any>;
  unSubscribe$ = new Subject<void>();
  selectedVal: any;
  data: DialogModel;
  inputForm: any;
  list: any;
  exportTypes: string[];
  selectedExportType: any;
  selectedExportTopics: any[] = [];

  constructor(private dataSurveyService: DataSurveyService, private formBuilder: FormBuilder) {
    this.exportTypes = ['Excel', 'Word', 'PDF'];
    this.selectedExportType = this.exportTypes[0];
  }

  ngOnInit() {
    this.inputForm = this.formBuilder.group({
      value: ['', Validators.required],
      exportTypeFormCtrl: new FormControl('', Validators.required),
      exportTopicFormCtrl: new FormControl('', Validators.required),
    });
    /*this.dropdownData$ = this.dataSurveyService.getSurveyUniqueResponse(this.data.input.executionId, this.data.input.surveyId).pipe(takeUntil(this.unSubscribe$));
    this.dropdownData$.subscribe(list => {
      this.list = list;
      this.init();
    });*/

    this.list = this.data.input.topics;
    this.init();
  }

  init() {
    if (this.list && this.list.length > 0) {
      const toSelect = this.list[0];
      this.selectedVal = toSelect;
      this.inputForm.get('value').setValue(toSelect);
      this.inputForm.get('exportTypeFormCtrl').setValue(this.exportTypes[0]);
      this.inputForm.get('exportTopicFormCtrl').setValue(this.list[0]);
      this.selectedExportTopics = this.list;
    }
  }

  onSelectionChange(event) {
    this.selectedVal = event.value;
  }

  ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  onOkClicked(): boolean {
    console.log(this.inputForm);
    this.data.input.executionSourceType = this.selectedVal.executionSourceType;
    if (this.selectedExportTopics.length === 0 || !this.inputForm.get('exportTypeFormCtrl')) {
      return;
    }
    this.data.input.selectedExportTopics = this.selectedExportTopics;
    this.data.input.selectedExportType = this.inputForm.get('exportTypeFormCtrl');
    return true;
  }

  onTopicSelectionChange(data) {
    if (this.selectedExportTopics.find(o => o === data)) {
      this.selectedExportTopics = this.selectedExportTopics.filter(o => o !== data);
    } else {
      this.selectedExportTopics.push(data);
    }
  }

  onExportTypeChanged() {

  }
}
